/*---------------------------------------------------------------------------
 The following JavaScript functions control Tender wizard client side functions
-----------------------------------------------------------------------------*/

var TECL_TenderGeneral = {

  // Close the accordian panel
  InitialiseAccordionControls: function() {

    $(".collapse").on('show.bs.collapse', function() {
      var parentNode = $(this).parent();
      parentNode.find(".panel-heading").addClass("opened");
      parentNode.find(".accordionClose").removeClass("hidden");
      parentNode.find(".accordionOpen").addClass("hidden");
    });

    $(".collapse").on('hide.bs.collapse', function() {
      var parentNode = $(this).parent();
      parentNode.find(".panel-heading").removeClass("opened");
      parentNode.find(".accordionClose").addClass("hidden");
      parentNode.find(".accordionOpen").removeClass("hidden");
    });

    $(".collapse").on('shown.bs.collapse', function() {
      $.fn.matchHeight._update();
      $(".tender-sidebar").trigger("sticky_kit:recalc");
    });

    $(".collapse").on('hidden.bs.collapse', function() {
      $.fn.matchHeight._update();
      $(".tender-sidebar").trigger("sticky_kit:recalc");
    });
  },

  // Update the progress bar to the new percentage
  UpdateProgressBar: function(currentStageNumber) {

    // Update the progress bar links
    var highestStageNumber = parseInt($("#highestStageNo").val());

    if (highestStageNumber === 0 || highestStageNumber > 4) {
      // Product Selection
      TECL_TenderGeneral.ShowTitleLink(".productSelection", true);
      TECL_TenderGeneral.ShowTitleLink(".quoteDuration", false);
      TECL_TenderGeneral.ShowTitleLink(".selectSuppliers", false);
      TECL_TenderGeneral.ShowTitleLink(".userInformation", false);

    } else if (highestStageNumber === 1) {
      // Quote Duration
      TECL_TenderGeneral.ShowTitleLink(".productSelection", true);
      TECL_TenderGeneral.ShowTitleLink(".quoteDuration", true);
      TECL_TenderGeneral.ShowTitleLink(".selectSuppliers", false);
      TECL_TenderGeneral.ShowTitleLink(".userInformation", false);

    } else if (highestStageNumber === 2) {
      // Select Supplier
      TECL_TenderGeneral.ShowTitleLink(".productSelection", true);
      TECL_TenderGeneral.ShowTitleLink(".quoteDuration", true);
      TECL_TenderGeneral.ShowTitleLink(".selectSuppliers", true);
      TECL_TenderGeneral.ShowTitleLink(".userInformation", false);

    } else if (highestStageNumber === 3) {
      // User Information
      TECL_TenderGeneral.ShowTitleLink(".productSelection", true);
      TECL_TenderGeneral.ShowTitleLink(".quoteDuration", true);
      TECL_TenderGeneral.ShowTitleLink(".selectSuppliers", true);
      TECL_TenderGeneral.ShowTitleLink(".userInformation", true);

    } else {
      // Completion Page
      TECL_TenderGeneral.ShowTitleLink(".productSelection", false);
      TECL_TenderGeneral.ShowTitleLink(".quoteDuration", false);
      TECL_TenderGeneral.ShowTitleLink(".selectSuppliers", false);
      TECL_TenderGeneral.ShowTitleLink(".userInformation", false);
    }

    // Set the progress alng the bar
    var percentageComplete;

    if (currentStageNumber === 0 || currentStageNumber > 4) {
      // Product Selection
      percentageComplete = "10%";
      TECL_TenderGeneral.ShowTitleLink(".productSelection", false);

    } else if (currentStageNumber === 1) {
      // Quote Duration
      percentageComplete = "30%";
      TECL_TenderGeneral.ShowTitleLink(".quoteDuration", false);

    } else if (currentStageNumber === 2) {
      // Select Supplier
      percentageComplete = "55%";
      TECL_TenderGeneral.ShowTitleLink(".selectSuppliers", false);

    } else if (currentStageNumber === 3) {
      // User Information
      percentageComplete = "80%";
      TECL_TenderGeneral.ShowTitleLink(".userInformation", false);

    } else {
      // Completion Page
      percentageComplete = "100%";
    }

    // Update Progress bar
    var widthText = percentageComplete;
    $("#tenderProgressBar").css("width", widthText);

    var labelText = percentageComplete + " Complete";
    $("#progress-bar-completionText").html(labelText);

  },

  // Display the please wait dialog
  DisplayPleaseWaitDlg: function() {
    $("#pleaseWaitDialog").modal("show");
  },

  // Hide the please wait dialog
  HidePleaseWaitDlg: function() {
    $("#pleaseWaitDialog").modal("hide");
  },

  // Display dlg for a set amount of time
  DisplayMessageDlg: function(message) {
    $("#messageDisplayDlgMessage").empty().html(message);
    $("#messageDisplayDlg").modal("show");

    function HideItemAddedDlg() {
      $("#messageDisplayDlg").modal("hide");
    }

    // Wait a set amount of time till the dialog is closed
    setTimeout(HideItemAddedDlg, 1000);
  },

  // Validate a email address
  IsEmailValid: function(emailText) {
    var expression = /\S+@\S+\.\S+/;
    var isValid = expression.test(emailText);
    return isValid;
  },

  // Define what title links to show
  ShowTitleLink: function(headerDivText, showLink) {
    if (showLink) {
      $(headerDivText).find(".progressBarLink").removeClass("hidden");
      $(headerDivText).find(".progressBarTitle").addClass("hidden");
    } else {
      $(headerDivText).find(".progressBarLink").addClass("hidden");
      $(headerDivText).find(".progressBarTitle").removeClass("hidden");
    }
  },

  // Continue to the a set stage
  ContinueToStage: function(stageNumber) {
    var cacheId = $("#cacheId").val();

    if (TECL_Master.AddLock("ContinueToStage")) {
      $.ajax({
        url: baseSiteUrl + "umbraco/Surface/Tender/ContinueToStage",
        type: "POST",
        data: {
          cacheId: cacheId,
          stageNumber: stageNumber
        },
        error: function(exc) {
          TECL_Master.ClearLock("ContinueToStage");
        },
        success: function(partialViewHtml) {
          TECL_Master.ClearLock("ContinueToStage");
          if (partialViewHtml) {
            $("#tenderPage").html(partialViewHtml);
          }
        }
      });
    }
  },

  InitialiseStickySidebar: function() {
    $(".tender-column").matchHeight({ property: 'min-height' });
    $.fn.matchHeight._update();
    $(".tender-sidebar").stick_in_parent();

    $(window).resize(function() {
      if ($(window).width() < 992) {
        $(".tender-sidebar").trigger("sticky_kit:detach");
      } else {
        $(".tender-sidebar").stick_in_parent();
      }
    });
  },

  // Show or hide the information section
  DisplayInfoSection: function(headerBarDiv, sectionDiv, refreshControls) {

    if (refreshControls && refreshControls == "false") {
      refreshControls = false;
    } else {
      refreshControls = true;
    }

    if (headerBarDiv && sectionDiv) {
      var $headerBarDiv = $(headerBarDiv);
      var $sectionDiv = $(sectionDiv);

      if ($headerBarDiv && $headerBarDiv.length > 0 && $sectionDiv && $sectionDiv.length > 0) {

        if ($sectionDiv.hasClass("hidden")) {
          // Show the panels info section
          $sectionDiv.removeClass("hidden");
          $sectionDiv.css("overflow", "visible");

          $headerBarDiv.find(".showInfoSection").addClass("hidden");
          $headerBarDiv.find(".hideInfoSection").removeClass("hidden");

          if (refreshControls) {
            // Force the values of the inputs to show
            $sectionDiv.find(":input").each(function() {
              var type = $(this).attr("type");
              if (type == "text" || type == "number") {
                $(this).focus();
              }
            });
          }
        } else {
          // Hide the panels info section
          $sectionDiv.addClass("hidden");
          $sectionDiv.css("overflow", "hidden");
          $headerBarDiv.find(".showInfoSection").removeClass("hidden");
          $headerBarDiv.find(".hideInfoSection").addClass("hidden");
        }
      }
    }
  },

  // Change the password display
  PasswordTextDisplay: function(passwordChanger, passwordInput) {
    var $pwordChanger = $(passwordChanger);
    var $pwordInput = $(passwordInput);

    if ($pwordInput.attr("type") === "password") {
      $pwordInput.attr("type", "text");
      $pwordChanger.addClass("fa-eye-slash");
      $pwordChanger.removeClass("fa-eye");
    } else {
      $pwordInput.attr("type", "password");
      $pwordChanger.removeClass("fa-eye-slash");
      $pwordChanger.addClass("fa-eye");
    }

  },

  // Change the classes of the checkbox labels 
  ChangedCheckboxLabelClass: function(checkboxElement) {
    var isChecked = $(checkboxElement).is(":checked");
    var labelId = $(checkboxElement).attr("data-labelId");

    if (labelId) {

      if (isChecked) {
        $("#" + labelId).addClass("checkboxChecked");
      } else {
        $("#" + labelId).removeClass("checkboxChecked");
      }
    }
  },

  /*
   * Method used to initialise for when a supplier
   * Accesses the project process page
   */
  InitialiseSupplierOnProject: function(href) {
    const $modal = $("#supplierOnTenderDlg");
    const returnFunc = function() { window.location.href = href; };
    $("body").on("click", "#supplierOnTenderDlg .btn-ok", returnFunc);
    $modal.on("hidden.bs.modal", returnFunc);
    $modal.modal("show");
  }

};
